import WaybillsTableColumnCourierPaymentRateType from './index.vue'
export default WaybillsTableColumnCourierPaymentRateType